import styles from "./BillingCard.module.scss";
import { IPaymentMethod } from "../../../../models/PaymentMethod";
import React, { useState } from "react";
import deleteIcon from "../../../../assets/images/icons/delete-white.svg";
import moreIcon from "../../../../assets/images/icons/more.svg";
import { useTranslation } from "react-i18next";
import useAppSelector from "../../../../hooks/useAppSelector";
import ConfirmPopup from "../../../../components/shared/ConfirmPopup/ConfirmPopup";
import attentionPath from "../../../../assets/images/icons/attention.svg";
import useAppDispatch from "../../../../hooks/useAppDispatch";
import { openSuccessMessage } from "../../../../store/message/messageSlice";
import { IUser } from "../../../../models/User";
import { handleError } from "../../../../helper/errorHandler";
import { usePaymentMethodsMutations } from "../../../../api/mutations/usePaymentMethodsMutations";

interface IBillingCardProps {
  paymentMethod: IPaymentMethod;
  getAllPaymentMethod: () => void;
}

const BillingCard: React.FC<IBillingCardProps> = ({ paymentMethod, getAllPaymentMethod }) => {
  const user = useAppSelector((state) => state.userProfileSlice.user) as IUser;
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [showMoreMenu, setShowMoreMenu] = useState(false);
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const { deleteCard, changeDefaultCard } = usePaymentMethodsMutations();

  const deletePaymentMethod = async (paymentMethodId: string) => {
    deleteCard(
      { id: paymentMethodId },
      {
        onSuccess: () => {
          dispatch(openSuccessMessage(t("CardDeletedSuccessfully")));
          getAllPaymentMethod();
        },
        onError: (e) => handleError(e, dispatch, t),
      }
    );
  };

  const changeMenuVisible = (value: boolean) => {
    setShowMoreMenu(value);
  };

  const setAsDefault = async (referenceId: string) => {
    if (!user) return;
    changeDefaultCard(
      { userId: user.id, referenceId },
      {
        onSuccess: () => {
          dispatch(openSuccessMessage(t("DefaultPaymentMethodChanged")));
          getAllPaymentMethod();
        },
        onError: (e) => handleError(e, dispatch, t),
      }
    );
  };

  const closeConfirmPopup = () => {
    setShowConfirmPopup(false);
  };

  const openConfirmPopup = () => {
    setShowConfirmPopup(true);
  };

  const confirmForDelete = () => {
    deletePaymentMethod(paymentMethod.referenceId);
    setShowConfirmPopup(false);
  };

  return (
    <>
      <div key={paymentMethod.referenceId} className={styles.item}>
        {showConfirmPopup && (
          <ConfirmPopup
            iconPath={attentionPath}
            title={t("DeletingConfirmation") + "!"}
            description={t("AreYouSureYouWantDeleteThisCard")}
            onClickYes={confirmForDelete}
            onClickNo={closeConfirmPopup}
          />
        )}
        <div className={styles.itemTop}>
          <p className={styles.default}>{paymentMethod.isDefault && t("Default")}</p>
          <div className={styles.iconWrapper}>
            {/*<img onClick={() => clickOnEdit(paymentMethod.id)} src={editIcon} alt={"edit"}/>*/}
            <img onClick={() => openConfirmPopup()} src={deleteIcon} alt={"delete"} />
            {!paymentMethod.isDefault && (
              <div
                className={`${styles.moreContainer} ${showMoreMenu && styles.active}`}
                onClick={() => changeMenuVisible(!showMoreMenu)}
              >
                <img className={styles.moreImage} src={moreIcon} alt={"more"} />
                <ul className={styles.moreMenu}>
                  <li
                    onClick={() => setAsDefault(paymentMethod.referenceId)}
                    className={styles.moreMenuItem}
                  >
                    {t("SelectAsDefault")}
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>
        <div className={styles.itemMain}>
          <p className={`${styles.text} ${styles.minWidth}`}>{paymentMethod.nameOnCard}</p>
        </div>
        <div className={styles.itemBottom}>
          <p className={styles.text}>****</p>
          <p className={styles.text}>****</p>
          <p className={styles.text}>****</p>
          <p className={styles.text}>{paymentMethod.last4}</p>
        </div>
        <img className={styles.cardBrand} src={paymentMethod.brandIconUrl} alt={"brand"} />
      </div>
    </>
  );
};

export default BillingCard;
